import { WorklistTabNames } from '~/pages/StudyList/Worklist/WorklistTabs';
import { FeatureFlags } from '~/src/constants/featureFlags';
import { useRemoveStudy } from '~/src/hooks/study/useRemoveStudy';
import { useStudyListTabs } from '~/src/hooks/study/useStudyListTabs';
import { useAddNewStudy } from '~/src/hooks/worklist/useAddNewStudy';
import { useUpdateStudy } from '~/src/hooks/worklist/useUpdateStudy';
import { ProcessUpdateWatcherProps, useWorklistCounterWatcher } from '~/src/hooks/worklist/useWorklistCounterWatcher';
import { UpdateEvent, useWorklistUpdates } from '~/src/hooks/worklist/useWorklistUpdates';
import { useFeatureFlagsStore } from '~/src/store/flagsStore';

export interface ProcessStudyUpdateProps extends ProcessUpdateWatcherProps {
  studyId: string;
}

export const useStudyUpdatesOrchestrator = () => {
  const hasFlag = useFeatureFlagsStore((state) => state.hasFlag);
  const isWorkListEnabled = hasFlag(FeatureFlags.EnableNewWorklistSection);
  const isAutomaticUpdatesEnabled = hasFlag(FeatureFlags.EnableAutomaticUpdatesWorklist);
  const { handleUpdateWorklistStudy } = useWorklistUpdates();
  const { processUpdateStudyListStudy } = useUpdateStudy();
  const { processInsertNewStudyListStudy } = useAddNewStudy();
  const { processUpdateCounter } = useWorklistCounterWatcher();
  const { processRemoveStudy } = useRemoveStudy();
  const { activeTab } = useStudyListTabs();

  const processStudy = ({
    studyOldPractitionerId,
    studyId,
    eventType,
    studyPractitionerId,
    userId,
    status,
    oldStatus,
  }: ProcessStudyUpdateProps) => {
    // TODO: Remove this flag when we integrate automatic update in study list AND we support worklist on all clients.
    if (!isWorkListEnabled && !isAutomaticUpdatesEnabled) return;

    processUpdateCounter({ eventType, studyOldPractitionerId, studyPractitionerId, userId, status, oldStatus });

    switch (eventType) {
      case UpdateEvent.DELETED: {
        if (activeTab === WorklistTabNames.WORKLIST) {
          // If study is assigned to the practitioner user, it means it is under worklist.
          if (studyPractitionerId === studyPractitionerId) {
            // Only proceeed with delete if we have it under our store.
            processRemoveStudy(studyId);
          }
        }

        // Remove from study list.
        // TODO: Uncomment this lines when we work on integrate automatic updates in study list.
        // processRemoveStudy(studyId)

        return;
      }
      case UpdateEvent.UPDATED: {
        if (activeTab === WorklistTabNames.WORKLIST) {
          return handleUpdateWorklistStudy(studyId, studyPractitionerId, studyOldPractitionerId, oldStatus, status);
        }

        return processUpdateStudyListStudy(studyId);
      }

      case UpdateEvent.CREATED: {
        return processInsertNewStudyListStudy(studyId);
      }
      default:
        return '';
    }
  };

  return { processStudy };
};
